'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var themes = require('@wow/themes');

const {
  textStyles: {
    labelSm
  },
  colors: {
    error
  }
} = themes.themeChakra;
const baseStyle = {
  text: Object.assign({
    color: error[100],
    marginTop: '0px !important'
  }, labelSm)
};
const FormErrorChakra = {
  baseStyle
};

exports.FormErrorChakra = FormErrorChakra;
